module.exports = __webpack_public_path__ + "Trykker-Regular.f7a9a92ad1a2eefcc825.ttf";


//////////////////
// WEBPACK FOOTER
// /home/leonhard/Projekte/braungardt/angular/src/assets/font/Trykker-Regular.ttf
// module id = ../../../../../src/assets/font/Trykker-Regular.ttf
// module chunks = styles